import redirectURL from "../redirectURL";
import DatePicker from 'react-datepicker'
import Select from 'react-select';
import moment from "moment";
import { useEffect, useMemo, useRef, useState } from 'react';
import SweetAlert from "react-bootstrap-sweetalert";
import { getDecoder, getHyphenDDMMMYYYYHHMM } from "../common/utils";
import { AgGridReact } from 'ag-grid-react';
import 'ag-grid-community/styles/ag-grid.css';
import 'ag-grid-community/styles/ag-theme-alpine.css';

const SummarisedTrackingData = () => {

    const trackingGridApiRef = useRef(null);
    const [loader, setLoader] = useState(false)
    const [show, setShow] = useState(false)
    const [title, setTitle] = useState('')
    const [type, setType] = useState('default')
    const [dates,setDates] = useState({
        startDate : new Date(moment().startOf('month')),
        endDate:new Date(moment.parseZone()),
        startFoDate:new Date(moment().startOf('month')),
        endFoDate :new Date(moment.parseZone()),
        forceClosureStartDate :new Date(moment().startOf('month')),
        forceClosureEndDate : new Date(moment.parseZone())
    })
    const [zones, setZones] = useState(null);
    const [dropdownZones, setDropdownZones] = useState({
        searchZone:'',
        searchForceClosureZone:''
    })
    const [dropdownPlants, setDropdownPlants] = useState({
        consignmentPlants: [],
        forceClosurePlants:[],
    })
    const [gridRowData, setGridRowData] = useState({
        consignmentRowData:null,
        foRowData:null,
        rowForceClosureData :null
    })  
    const [selectedPlant, setSelectedPlant] = useState({
        consignmentPlant : '',
        forceClosurePlant:''
    }) 
    const [detailCellRendererParams12, setdetailCellRendererParams12] = useState({
            consignmentDetailRenderParams : null,
            forceClosureDetailRenderParmas :null
    })
    const [totalData, setTotalData] = useState(null);
    const [totalFoData, setTotalFoData] = useState(null); // new state for total row
    const [allPlants, setAllPlants] = useState([]);
    const gridApiRef = useRef(null);
    const forceClosureApiRef = useRef(null);
    const [totalForceClosure,setTotalForceClosure] = useState({
        totalForceClosureFoCount:[],
        totalForceClosureFoData:null,
        totalForceClosureDeliveryCount:null,
        totalForceClosureDeliveryData:[]
    })
    const [loading,setLoading] = useState({
        consignmentloader:false,
        foloader : false,
        forceClosureloader :false
    })
    const defaultColDef =  {
            sortable: true,
            filter: true,
            autoSizeColumns: true,
            resizable: true,
            pivot: true,
        };
    const closeAlert = () => {
        setShow(false)
        setTitle('')
        setType('default')
    }


   const handleStartDateChange = (name, date) => {
    const { endDate, endFoDate, forceClosureEndDate } = dates;

    if (name === "startDate" && endDate && date > endDate) {
        setShow(true);
        setTitle("To Date should be greater than From Date");
        setType("danger");
        return;
    }

    if (name === "startFoDate" && endFoDate && date > endFoDate) {
        setShow(true);
        setTitle("To Date should be greater than From Date");
        setType("danger");
        return;
    }

    if (name === "startForceClosureDate" && forceClosureEndDate && date > forceClosureEndDate) {
        setShow(true);
        setTitle("To Date should be greater than From Date");
        setType("danger");
        return;
    }

    setDates(prev => ({ ...prev, [name]: date }));
};


    const handleEndDateChange = (name, date) => {
    const { startDate, startFoDate, forceClosureStartDate } = dates;
    if (name == "endDate" && (startDate && date < startDate)) {
        setShow(true);
        setTitle("To Date should be greater than From Date");
        setType("danger");
        return;
    }

    if (name == "endFoDate" && startFoDate && date < startFoDate) {
        setShow(true);
        setTitle("To Date should be greater than From Date");
        setType("danger");
        return;
    }

    if (name == "endForceClosureDate" && forceClosureStartDate && date < forceClosureStartDate) {
        setShow(true);
        setTitle("To Date should be greater than From Date");
        setType("danger");
        return;
    }

    setDates(prev => ({ ...prev, [name]: date }));
};

    const submitFoEvent = async (e) => {
        e.preventDefault()
        getFoData()
    }
    const getFoData = async () => {
        setLoading(prev => ({ ...prev, foloader: true }))
        let query = {
            sdate: moment.parseZone(new Date(dates.startFoDate)).format("YYYY-MM-DD"),
            edate: moment.parseZone(new Date(dates.endFoDate)).format("YYYY-MM-DD"),
        }
        await redirectURL.post('consignments/getFoSummaryLevelBilling', query)
            .then((response) => {
                if (response.data.status == 'Success') {
                    let foData = response.data ?? [];
                    const entries = Object.entries(foData);
                    const otherEntries = entries.filter(([name]) => name !== "total_summary" && name !== "status");
                    const SummarisedFoData = [
                        ...otherEntries.map(([consigner_name, values]) => {
                            const { status, ...rest } = values; // Exclude 'status'
                            return {
                                consigner_name,
                                ...rest,
                                isTotal: false,
                            };
                        }),
                    ];
                    setGridRowData(prev => ({ ...prev, foRowData: SummarisedFoData }))
                    const totalEntry = entries.find(([name]) => name === "total_summary");
                    if (totalEntry) {
                        const [, totalValues] = totalEntry;

                        const processedTotals = {};
                        Object.entries(totalValues).forEach(([key, value]) => {
                            if (Array.isArray(value)) {
                                const actualArray = Array.isArray(value[0]) ? value[0] : value;
                                processedTotals[`${key}_count`] = actualArray.length;
                                processedTotals[`${key}_data`] = actualArray;
                            } else {
                                processedTotals[key] = value;
                            }
                        });
                        setTotalFoData({
                            consigner_name: "TOTAL",
                            ...processedTotals,
                            isTotal: true,
                        });
                    }


                    setLoading(prev => ({ ...prev, foloader: false }))
                }
                else if (response.data.status == 'Failure') {
                    setGridRowData(prev => ({ ...prev, foRowData: [] }))
                    setTotalFoData([])
                }
            })

            .catch((error) => {
                console.error('Error fetching data:', error);
            })
    }
    const getForceClosureData = async () => {
        setLoading(prev=>({...prev,forceClosureloader:true}))
        let params = {
            sdate: moment.parseZone(new Date(dates.forceClosureStartDate)).format("YYYY-MM-DD"),
            edate: moment.parseZone(new Date(dates.forceClosureEndDate)).format("YYYY-MM-DD")
        }
        if (selectedPlant?.forceClosurePlant.length && selectedPlant?.forceClosurePlant[0].value !== "ALL") {
            params["plant_codes"] = selectedPlant?.forceClosurePlant.map(e => e.value)
        }
        else if (dropdownZones?.searchForceClosureZone.length && dropdownZones?.searchForceClosureZone[0].value !== "ALL") {
            params["zone"] = dropdownZones?.searchForceClosureZone.map(e => e.value)
        }
        await redirectURL.post("/consignments/forceClosureConsignmentsData", params)
            .then((response) => {
                let flattenedData = []
                Object.entries(response.data).forEach(([reasonKey, nestedValue]) => {
                    Object.entries(nestedValue).forEach(([primaryReason, value]) => {
                        if (primaryReason === "total_data") {
                            // Set different state based on reasonKey
                            if (reasonKey === "fo_level_data") {
                                setTotalForceClosure(prev =>({...prev,
                                    totalForceClosureFoCount:(value.count),
                                    totalForceClosureFoData:(value.data)
                                }))
                            } else if (reasonKey === "delivery_level_data") {
                                setTotalForceClosure(prev =>({...prev,
                                    totalForceClosureDeliveryCount : (value.count),
                                    totalForceClosureDeliveryData:(value.data)
                                }))
                            }
                            return;
                        }
                        Object.entries(value).forEach(([secondaryReason, detail]) => {
                            // Try to find existing entry for the same primary & secondary reason
                            let existing = flattenedData.find(
                                (item) =>
                                    item.primary_reasons === primaryReason &&
                                    item.secondary_reasons === secondaryReason
                            );
                            if (!existing) {
                                existing = {
                                    primary_reasons: primaryReason,
                                    secondary_reasons: secondaryReason,
                                    fo_level_count: 0,
                                    delivery_count: 0,
                                    fo_data: [],
                                    delivery_data: [], // Optional: adjust based on needs
                                };
                                flattenedData.push(existing);
                            }
                            if (reasonKey === "fo_level_data") {
                                existing.fo_level_count = detail.count;
                                existing.fo_data = detail.data;
                            } else if (reasonKey === "delivery_level_data") {
                                existing.delivery_count = detail.count;
                                existing.delivery_data = detail.data;
                            }
                        });
                    });
                });
                setGridRowData(prev=>({...prev,rowForceClosureData:flattenedData}))
                setLoading(prev=>({...prev,forceClosureloader:false}))
            })
    }
    const submitForceClosureEvent =(e) =>{
        e.preventDefault()
        getForceClosureData()
    }
  
    const foColumnDefs =  [
            {
                headerName: 'Plant Name',
                field: 'consigner_name',
                cellClass: (params) => params.node.rowPinned ? 'totalPinnedRows' : ''
            },
            {
                headerName: 'FO Created',
                field: 'total_fo_numbers',
                 cellClass: (params) => params.node.rowPinned ? 'totalPinnedRows' : ''

            },
            {
                headerName: 'FO Approved',
                field: 'approved_fo_numbers',
                cellClass: (params) => params.node.rowPinned ? 'totalPinnedRows' : ''

            },
            {
                headerName: 'Tracking Mode',
                headerClass: 'header-big',
                headerStyle: { textAlign: "center" },
                children: [
                    {
                        headerName: "GPS Mode",
                        field: "GPS_tracked",
                        width: 118,
                        cellClass: (params) => params.node.rowPinned ? 'totalPinnedRows' : ''

                    },
                    {
                        headerName: "SIM Mode",
                        field: "SIM_tracked",
                        width: 185,
                        cellClass: (params) => params.node.rowPinned ? 'totalPinnedRows' : ''

                    },
                ]
            },
            {
                headerName: "Events Pushed",
                headerClass: 'header-big',
                headerStyle: { textAlign: "center" },
                children: [
                    {
                        headerName: 'Gate In',
                        field: 'plant_in',
                        width: 130,
                        cellClass: (params) => params.node.rowPinned ? 'totalPinnedRows' : ''
                    },
                    {
                        headerName: 'Gate Out',
                        field: "plant_out",
                        width: 130,
                        cellClass: (params) => params.node.rowPinned ? 'totalPinnedRows' : ''
                    },
                    {
                        headerName: "Dealer In",
                        field: "dealer_in",
                        width: 130,
                        cellClass: (params) => params.node.rowPinned ? 'totalPinnedRows' : ''
                    },
                    {
                        headerName: "Dealer Out",
                        field: "dealer_out",
                        width: 130,
                        cellClass: (params) => params.node.rowPinned ? 'totalPinnedRows' : ''
                    }
                ]
            },
            {
                headerName: "Super Tracking Count",
                field: "super_tracked_fo_numbers",
                width: 150,
                cellClass: (params) => params.node.rowPinned ? 'totalPinnedRows' : ''

            },
            {
                headerName: "Super Tracking %",
                field: "super_tracking_fo_percentage",
                width: 160,
                cellClass: (params) => params.node.rowPinned ? 'totalPinnedRows' : ''
            },
            
        ];
    const trackingColumndefs = [
            {
                headerName: "Plant Name",
                width: 125,
                field: "consigner_name",
                pinned: "left",
                cellClass: (params) => params.node.rowPinned ? 'totalPinnedRows' : ''

            },
            {
                headerName: "Plant Code",
                width: 125,
                field: "consigner_code",
                pinned: "left",
                cellClass: (params) => params.node.rowPinned ? 'totalPinnedRows' : ''
            },
            {
                headerName: 'FO Details',
                headerClass: 'header-big',
                children: [
                    {
                        headerName: "FO Created (Enmovil)",
                        field: "fo_created",
                        width: 125,
                        valueGetter: function (params) {
                            return params?.data?.fo_created?.count ?? 0
                        },
                        cellClass: (params) => params.node.rowPinned ? 'totalPinnedRows' : ''
                    },
                    {
                        headerName: "Delay in Creation",
                        field: "delayed_fo_created",
                        width: 125,
                        valueGetter: function (params) {
                            return params?.data?.delayed_fo_created?.count ?? 0
                        },
                        cellClass: (params) => params.node.rowPinned ? 'totalPinnedRows' : ''
                    },
                ]
            },
            {
                headerName: 'Tracking Mode',
                headerClass: 'header-big',
                headerStyle: { textAlign: "center" },
                children: [
                    {
                        headerName: "GPS Mode",
                        field: "gps_mode",
                        width: 118,
                        valueGetter: function (params) {
                            return params?.data?.gps_mode?.count ?? 0
                        },
                       cellClass: (params) => params.node.rowPinned ? 'totalPinnedRows' : ''
                    },
                    {
                        headerName: "Sim Consent Created",
                        field: "sim_mode",
                        width: 125,
                        valueGetter: function (params) {
                            return params?.data?.sim_mode?.count ?? 0
                        },
                       cellClass: (params) => params.node.rowPinned ? 'totalPinnedRows' : ''
                    },
                ]
            },
            {
                headerName: 'Consent Status',
                headerClass: 'header-big',
                children: [
                    {
                        headerName: "Consent Approved",
                        field: "consent_approved",
                        width: 116,
                        valueGetter: function (params) {
                            return params?.data?.consent_approved?.count ?? 0
                        },
                       cellClass: (params) => params.node.rowPinned ? 'totalPinnedRows' : ''
                    },
                    {
                        headerName: "Consent Pending",
                        field: "consent_pending",
                        width: 116,
                        valueGetter: function (params) {
                            return params?.data?.consent_pending?.count ?? 0
                        },
                       cellClass: (params) => params.node.rowPinned ? 'totalPinnedRows' : ''
                    },
                    {
                        headerName: "Not Registered/BSNL No.",
                        field: "not_registered_sim_or_bsnl",
                        width: 148,
                        valueGetter: function (params) {
                            return params?.data?.not_registered_sim_or_bsnl?.count ?? 0
                        },
                       cellClass: (params) => params.node.rowPinned ? 'totalPinnedRows' : ''
                    },
                    {
                        headerName: "Invalid Mobile No.",
                        field: "invalid_mobile_no",
                        width: 125,
                        valueGetter: function (params) {
                            return params?.data?.invalid_mobile_no?.count ?? 0
                        },
                       cellClass: (params) => params.node.rowPinned ? 'totalPinnedRows' : ''
                    },
                    {
                        headerName: "Consent Success %",
                        field: "consent_success_percent",
                        width: 125,
                        valueGetter: function (params) {
                            return (params?.data?.consent_success_percent ?? 0) + "%"
                        },
                       cellClass: (params) => params.node.rowPinned ? 'totalPinnedRows' : ''
                    },
                ],
            },
            {
                headerName: 'App Usage',
                headerClass: 'header-big',
                children: [
                    {
                        headerName: "Mobile Gate In Given",
                        field: "manual_gate_in_given",
                        width: 128,
                        valueGetter: function (params) {
                            return params?.data?.manual_gate_in_given?.count ?? 0
                        },
                       cellClass: (params) => params.node.rowPinned ? 'totalPinnedRows' : ''
                    },
                    {
                        headerName: "Mobile Gate in not given",
                        field: "manual_gate_in_not_given",
                        width: 128,
                        valueGetter: function (params) {
                            return params?.data?.manual_gate_in_not_given?.count ?? 0
                        },
                       cellClass: (params) => params.node.rowPinned ? 'totalPinnedRows' : ''
                    },
                    {
                        headerName: "Mobile Gate Out Given",
                        field: "manual_gate_out_given",
                        width: 128,
                        valueGetter: function (params) {
                            return params?.data?.manual_gate_out_given?.count ?? 0
                        },
                       cellClass: (params) => params.node.rowPinned ? 'totalPinnedRows' : ''
                    },
                    {
                        headerName: "Mobile Gate Out not given",
                        field: "manual_gate_out_not_given",
                        width: 128,
                        valueGetter: function (params) {
                            return params?.data?.manual_gate_out_not_given?.count ?? 0
                        },
                       cellClass: (params) => params.node.rowPinned ? 'totalPinnedRows' : ''
                    },
                    {
                        headerName: "Mobile app usage %",
                        field: "mobile_app_usage_percent",
                        width: 128,
                        valueGetter: function (params) {
                            return (params?.data?.mobile_app_usage_percent ?? 0) + "%"
                        },
                       cellClass: (params) => params.node.rowPinned ? 'totalPinnedRows' : ''
                    },
                ]
            },
            {
                headerName: 'Tracking status',
                headerClass: 'header-big',
                children: [
                    {
                        headerName: "Trackable",
                        field: "tracable",
                        width: 116,
                        valueGetter: function (params) {
                            return params?.data?.tracable?.count ?? 0
                        },
                       cellClass: (params) => params.node.rowPinned ? 'totalPinnedRows' : ''
                    },
                    {
                        headerName: "Non Tracable",
                        field: "non_tracable",
                        width: 138,
                        valueGetter: function (params) {
                            return params?.data?.non_tracable?.count ?? 0
                        },
                       cellClass: (params) => params.node.rowPinned ? 'totalPinnedRows' : ''
                    },
                ]
            },
            {
                headerName: 'Trip Closure',
                headerClass: 'header-big',
                children: [
                    {
                        headerName: "Geofence Closed",
                        field: "geofence_closed",
                        width: 112,
                        valueGetter: function (params) {
                            return params?.data?.geofence_closed?.count ?? 0
                        },
                       cellClass: (params) => params.node.rowPinned ? 'totalPinnedRows' : ''
                    },
                    {
                        headerName: "Manual Close",
                        field: "manual_closed",
                        width: 112,
                        valueGetter: function (params) {
                            return params?.data?.manual_closed?.count ?? 0
                        },
                       cellClass: (params) => params.node.rowPinned ? 'totalPinnedRows' : ''
                    },
                    {
                        headerName: "Intransit",
                        field: "intransit",
                        width: 100,
                        valueGetter: function (params) {
                            return params?.data?.intransit?.count ?? 0
                        },
                       cellClass: (params) => params.node.rowPinned ? 'totalPinnedRows' : ''
                    },
                ]
            },
            {
                headerName: 'Report',
                headerClass: 'header-big',
                children: [
                    {
                        headerName: "Tracking %",
                        field: "tracking_percentage",
                        width: 121,
                        valueGetter: function (params) {
                            return (params?.data?.tracking_percentage ?? 0) + "%"
                        },
                       cellClass: (params) => params.node.rowPinned ? 'totalPinnedRows' : ''
                    },
                    {
                        headerName: "Super Tracking",
                        field: "super_tracking_percentage",
                        width: 144,
                        valueGetter: function (params) {
                            return (params?.data?.super_tracking_percentage ?? 0) + "%"
                        },
                       cellClass: (params) => params.node.rowPinned ? 'totalPinnedRows' : ''
                    },
                    {
                        headerName: "e-POD submitted",
                        field: "epod",
                        width: 116,
                        valueGetter: function (params) {
                            return params?.data?.epod?.count ?? 0
                        },
                       cellClass: (params) => params.node.rowPinned ? 'totalPinnedRows' : ''
                    },
                ]
            },
        ];
    const forceClosurecolumnDefs =[
            {
                headerName: "Primary Reasons",
                field: 'primary_reasons',
                rowSpan: params => {
                return params.data?.rowSpan > 1 ? params.data.rowSpan : 1;
                    },
                cellClass : (params) => params.node.rowPinned ? 'totalPinnedRows' : null,
            },
            {
                headerName: "Secondary Reasons",
                field: "secondary_reasons",
                 cellClass: (params) => params.node.rowPinned ? 'totalPinnedRows': null,
            },
            {
                headerName:"FO Level Count",
                field:"fo_level_count",
                onCellClicked:(params) =>{
                     if (params.node.data?.primary_reasons == 'Total') {
                        downloadJSONAsCSV(params.node.data?.fo_level_data,"FO Level Count", dates?.forceClosureStartDate , dates?.forceClosureEndDate)
                    }
                    else {
                        if (params.node) {
                            const isExpanded = params.node.expanded;
                            if (!isExpanded) {
                                setdetailCellRendererParams12(prev=>({...prev,forceClosureDetailRenderParmas:{
                                    detailGridOptions:{columnDefs:forceDetailcolumnDefs,
                                    defaultColDef:{
                                        flex:1
                                    }},
                                    getDetailRowData:(params2)=>{
                                        params2.successCallback(params2?.data?.fo_data || [])
                                    }
                                }}))
                            }
                            params.node.setExpanded(!isExpanded);
                        }
                    }
                },
                cellClass: (params) => params.node.rowPinned ? "totalPinnedRows": '',
            },
            {
                headerName: "Delivery Level Count",
                field: "delivery_count",
                onCellClicked: (params) => {
                    if (params.node.data?.primary_reasons == 'Total') {
                        downloadJSONAsCSV(params.node.data?.delivery_data , "Delivery Level Count",dates?.forceClosureStartDate,dates?.forceClosureEndDate)
                    }
                    else {
                        if (params.node) {
                            const isExpanded = params.node.expanded;
                            if (!isExpanded) {
                                setdetailCellRendererParams12(prev=>({...prev,forceClosureDetailRenderParmas:{
                                    detailGridOptions:{
                                        columnDefs : forceDetailcolumnDefs,
                                        defaultColDef :{
                                            defaultColDef:{
                                                flex:1
                                            }
                                        }
                                    },
                                    getDetailRowData:(params2)=>{params2.successCallback(params2?.data?.delivery_data || [])}
                                }}))
                            }
                            params.node.setExpanded(!isExpanded);
                        }
                    }
                },
                cellClass: (params)=> params.node.rowPinned ? "totalPinnedRows" : ''
            }
    ];
    const forceDetailcolumnDefs = [
                    {
                        headerName: "FO Number",
                        field: "fo_number",
                    },
                    {
                        headerName: "Vehicle Number.",
                        field: "truck_no",
                    },
                    {
                        headerName: "Driver No.",
                        field: "driver_mobile_no",
                    },
                    {
                        headerName: "Created Date",
                        field: "created_date",
                        valueGetter: function (params) {
                            return ![undefined,''].includes(params.data.created_date) ? getHyphenDDMMMYYYYHHMM(params.data.created_date) :''
                        },
                        comparator: (date1, date2) => sortingDatesInGrid(date1, date2),
                    },
                    {
                        headerName: "Plant Name",
                        field: "consigner_name",
                    }
                ]
    ;
    
   const foGridPinnedBottomRow = totalFoData
    ? [
        {
            consigner_name: "TOTAL",
            total_fo_numbers: totalFoData?.total_fo_numbers_count,  // count field
            total_fo_numbers_data: totalFoData?.total_fo_numbers_data, // store actual array
            approved_fo_numbers: totalFoData?.approved_fo_numbers_count,
            approved_fo_numbers_data : totalFoData?.approved_fo_numbers_data,
            SIM_tracked: totalFoData?.SIM_tracked_count,
            SIM_tracked_data : totalFoData?.SIM_tracked_data, 
            GPS_tracked:totalFoData?.GPS_tracked_count,
            GPS_tracked_data : totalFoData?.GPS_tracked_data,
            plant_in:totalFoData?.plant_in_count,
            plant_in_data:totalFoData?.plant_in_data,
            plant_out:totalFoData?.plant_out_count,
            plant_out_data : totalFoData?.plant_out_data,
            dealer_in:totalFoData?.dealer_in_count,
            dealer_in_data:totalFoData?.dealer_in_data,
            dealer_out:totalFoData?.dealer_out_count,
            dealer_out_data:totalFoData?.dealer_out_data,
            super_tracked_fo_numbers:totalFoData?.super_tracked_data_count,
            super_tracked_fo_numbers_data:totalFoData?.super_tracked_data_data,
            super_tracking_fo_percentage : totalFoData?.super_tracking_fo_percentage,
            isTotal: true
        }
      ]
    : [];

         const consignmentGridpinnedBottomRow = totalData
        ? [
            {
                consigner_name: "TOTAL",
                ...totalData,
                isTotal: true,
                download: "download", // This field is used in the above column
            },
        ]
        : [];
    const forceClosureGridPinnedBottomRow = [{
        primary_reasons: 'Total',
        secondary_reasons: '',
        fo_level_count: totalForceClosure?.totalForceClosureFoCount,
        fo_level_data: totalForceClosure?.totalForceClosureFoData,
        delivery_count:totalForceClosure?.totalForceClosureDeliveryCount,
        delivery_data:totalForceClosure?.totalForceClosureDeliveryData,
    }];
    const consignmentDetailColDefs = [ 
                    {
                        headerName: "FO Number",
                        field: "fo_number",
                    },
                    {
                        headerName: "Vehicle No.",
                        field: "truck_no",
                    },
                    {
                        headerName: "Driver No.",
                        field: "driver_mobile_no",
                    },
                    {
                        headerName: "Created Date",
                        field: "created_date",
                        valueGetter: function (params) {
                            return ![undefined,''].includes(params.data.created_date) ? getHyphenDDMMMYYYYHHMM(params.data.created_date) :''
                        },
                        comparator: (date1, date2) => sortingDatesInGrid(date1, date2),
                    },
                ];
        const onCellClicked = (params) => {
        let rowData = params.data
         if(params.data?.consigner_name=="TOTAL"){
            downloadJSONAsCSV(rowData[params.colDef.field]?.data ? rowData[params.colDef.field]?.data : '', params?.colDef?.headerName,dates?.startDate,dates?.endDate )
        }
        else{
        if (rowData[params.colDef.field]?.data != undefined && Array.isArray(rowData[params.colDef.field]?.data)) {
            params.node.setExpanded(!params.node.expanded)
            setdetailCellRendererParams12(prev=>({...prev,consignmentDetailRenderParams:({
                detailGridOptions :{
                    columnDefs:consignmentDetailColDefs,
                    defaultColDef:{
                        flex:1
                    }
                },
                getDetailRowData: (params2) => {
                    params2.successCallback(rowData[params.colDef.field]?.data);
                },
            })}))
        }
    }
    }
     useEffect(() => {
         getData()
         getFoData()
         getForceClosureData()
        redirectURL.post("consignments/allPlantCodes",)
            .then(res => {
                if (res.data?.length > 0) {
                    let zones = []
                    res.data.forEach(element => {
                        if (zones.find(e => e == element.consigner_zone) == undefined && element.consigner_zone != undefined)
                            zones.push(element.consigner_zone)
                    });
                     zones =  zones.map(e => { return { label: e, value: e } })
                    setZones(zones)
                    let plantList = res.data
                        .filter(e => e.consigner_zone !== undefined)
                        .map(e => ({
                            label: `${e.consigner_name} (${e.consigner_code})`,
                            value: e.consigner_code,
                            consigner_zone: e.consigner_zone
                        }));
                    setAllPlants(plantList)
                }
            })
             .catch(err => console.log(err))
     }, [])
    const getData = async () => {
        setLoading(prev =>({...prev,consignmentloader:true}))
        let query = {
            sdate: moment.parseZone(new Date(dates.startDate)).format("YYYY-MM-DD"),
            edate: moment.parseZone(new Date(dates.endDate)).format("YYYY-MM-DD")
        }
        if (selectedPlant?.consignmentPlant.length && selectedPlant?.consignmentPlant[0].value !== "ALL") {
            query["plant_codes"] = selectedPlant?.consignmentPlant.map(e => e.value)
        }
        else if (dropdownZones?.searchZone.length && dropdownZones?.searchZone[0].value !== "ALL") {
            query["zone"] = dropdownZones?.searchZone.map(e => e.value)
        }
        await redirectURL.post('consignments/getConsignmentTrackingReport', query)
           .then((response2) => {
                trackingGridApiRef.current?.showLoadingOverlay();
                if(response2.data.status == 'success'){
                setTotalData(response2.data.total_data)
                setGridRowData(prev=>({...prev,consignmentRowData:response2.data.consignment_tracking_report ?? []}))
                setLoading(prev=>({...prev,consignmentloader:false}))
                }
                else{
                    setLoading(prev=>({...prev,consignmentloader:false}))
                }
            })
            .catch((error) => {
                console.error('Error fetching data:', error);
                return error
            })
    }

      const onChangeZone = async (zone,actionMeta) => {
         if (actionMeta?.action === "clear") {
             setDropdownZones(prev => ({
                 ...prev,
                 searchZone: "",               // or [] or null based on your logic
                 searchForceClosureZone: "",   // optionally clear other fields too
             }));
             setSelectedPlant(prev=>({...prev,consignmentPlant : [],forceClosurePlant:[]}))
        return;
    }
          if (Array.isArray(zone)) {
              const filteredZones = zone.filter(z => z.value !== 'All')
              const selectedZoneValues = filteredZones.map(z => z.value);
              const filtered = allPlants.filter(p =>
                  selectedZoneValues.includes(p.consigner_zone)
              );
              if (actionMeta.name == "searchZone") {
                    setDropdownZones(prev => ({...prev , [actionMeta.name] : zone}))
                    setDropdownPlants(prev=>({...prev,consignmentPlants:(filtered)}))
    }
    else{
        setDropdownZones(prev =>({...prev , [actionMeta.name] : zone}))
        setDropdownPlants(prev=>({...prev,forceClosurePlants:(filtered)}))
    }
}
    else{
        setDropdownZones(prev=>({...prev, searchZone:[],searchForceClosureZone:[]}))
    }
}
   const onChangePlantCode = async (plant_code,actionMeta) => {
    if(actionMeta.name == 'consignmentPlant'){
        setSelectedPlant(prev=>({...prev,consignmentPlant : plant_code}))
    }
    else{
        setSelectedPlant(prev=>({...prev,forceClosurePlant:plant_code}))
    }
}
     const submitEvent = async (e) => {
        e.preventDefault()
        getData()
    }
    const handleCellClick = (params) => {
    const field = params.colDef.field;
    // if(field == 'super_tracking_fo_percentage'){
    //     setShow(true)
    //     setType('danger')
    //     setTitle('No Data To Export')
    // }
    // else{
    if (params.node.rowPinned === "bottom") {
        const dataKey = `${field}_data`;
        const rowData = params.data[dataKey];
        if (rowData && Array.isArray(rowData)) {
            downloadJSONAsCSV(rowData, params?.colDef?.headerName, dates?.startFoDate, dates?.endFoDate);
        }
    }
// }
};
     function downloadJSONAsCSV(data, filename = "",start_date = "",end_date ='' ) {
        try{
        if (!Array.isArray(data) || data.length === 0) {
            setTitle("No data available for export.");
            setType("danger");
            setShow(true)
            return;
        }
        // Extract headers
        const headers = Object.keys(data[0]);
        const csvRows = [];
        // Add header row
        csvRows.push(headers.join(','));
        const formattedStartDate = moment(new Date(start_date)).format('DD-MMM-YYYY HH:mm'); // Optional: sanitize
        const formattedEndDate = moment(new Date(end_date)).format('DD-MMM-YYYY HH:mm');;
        const finalFilename = `${filename}_${formattedStartDate}_${formattedEndDate}.csv`;

        // Add data rows
        data.forEach(row => {
            const values = headers.map(header => {
                let val = row[header];
                // Escape quotes
                if (typeof val === 'string') {
                    val = val.replace(/"/g, '""');
                }
                return `"${val ?? ''}"`; // wrap in quotes
            });
            csvRows.push(values.join(','));
        });

        // Create CSV blob and trigger download
        const blob = new Blob([csvRows.join('\n')], { type: 'text/csv' });
        const link = document.createElement('a');
        link.href = URL.createObjectURL(blob);
        link.download = finalFilename;
        link.click();
    }
    catch(error){
        console.error("Error", error)
        return error
    }
    }

    return (
        <div className="container-fluid">
            <SweetAlert
                show={show}
                type={type}
                title={title}
                onConfirm={closeAlert}
            >
            </SweetAlert>
            <h5 className="mb-15p fbold f16">
                <i className="icon-map cus-i"></i> <span style={{ fontWeight: "600" }}>Consignment Tracking Report</span>
            </h5>
            <div className="card">
                       <div className="card-body row">
                <div className="summarised_title mb-2">Tracking Report</div>
                                              <div className="col-xl-12 col-lg-12 row">
                                <div className="col-xl-2 col-lg-2 form-group">
                                <div className=""><label>Created From Date</label></div>
                                 <div className="">
                                         <DatePicker
                                            selected={dates.startDate}
                                            onChange={(date) =>handleStartDateChange('startDate',date)}
                                            maxDate={new Date()}
                                            name="startDate"
                                            autoComplete="off"
                                            dateFormat="dd/MM/yyyy"
                                            className="datepicker-custom"
                                        />
                                    </div>
                                </div>
                                <div className="col-xl-2 col-lg-2 form-group">
                                    <div className=""><label>Created To Date</label></div>
                                    <div className="">
                                        <DatePicker
                                            selected={dates.endDate}
                                            onChange={(date) =>handleEndDateChange('endDate',date)}
                                            maxDate={new Date()}
                                            name="endDate"
                                            autoComplete="off"
                                            dateFormat="dd/MM/yyyy"
                                            className="datepicker-custom"
                                        />
                                    </div>
                                </div>
                                <div className="form-group col-xl-3 col-lg-3" style={{ zIndex: "8" }}>
                                    <label>Select Zone</label>
                                    <Select
                                        className="border-radius-0"
                                        id="searchZone"
                                        name ="searchZone"
                                        style={{ borderRadius: "0px" }}
                                        value={dropdownZones?.searchZone}
                                        onChange={(value, actionMeta) => onChangeZone(value, actionMeta)}
                                        options={zones}
                                        isMulti={true}
                                    />
                                </div>
                                {dropdownZones?.searchZone.length >= 1 ? <div className="form-group col-xl-3 col-lg-3" style={{ zIndex: "8" }}>
                                    <label>Select Plant </label>
                                    <Select
                                        className="border-radius-0"
                                        isMulti={true}
                                        id="consignmentPlant"
                                        name = 'consignmentPlant'
                                        style={{ borderRadius: "0px" }}
                                        value={selectedPlant?.consignmentPlant}
                                        onChange={(value,actionMeta) => onChangePlantCode(value,actionMeta)}
                                        options={dropdownPlants?.consignmentPlants}
                                        closeMenuOnSelect={false}
                                    />
                                </div> :<></>}
                                <div className="form-group col-xl-1 col-lg-1">
                                    <button type="button" style={{ marginTop: "35px" }} onClick={submitEvent} className={"btn btn-success "}>Submit</button>
                                </div>
                            </div>
                    <div id="ctr-gird" className={"ag-theme-balham mt-8 summarised_grid"}>
                        <AgGridReact
                            onGridReady={(params) => {
                                trackingGridApiRef.current = params.api
                            }}
                            loading={loading?.consignmentloader}
                            columnDefs={trackingColumndefs}
                            rowData={gridRowData?.consignmentRowData}
                            defaultColDef={defaultColDef}
                            pagination={true}
                            groupHeaderHeight={50}
                            headerHeight={50}
                            paginationPageSize={50}
                            enableRangeSelection={true}
                            enableCellContextMenu={true}
                            masterDetail={true}
                            detailCellRendererParams={detailCellRendererParams12?.consignmentDetailRenderParams}
                            pinnedBottomRowData={consignmentGridpinnedBottomRow}
                            onCellClicked={onCellClicked}
                            sideBar={{
                                toolPanels: [
                                    {
                                        id: "columns",
                                        labelDefault: "Columns",
                                        labelKey: "columns",
                                        iconKey: "columns",
                                        toolPanel: "agColumnsToolPanel",
                                        toolPanelParams: {
                                            suppressPivotMode: true,
                                            suppressRowGroups: true,
                                            suppressValues: true,
                                        }
                                    },
                                    {
                                        id: "filters",
                                        labelDefault: "Filters",
                                        labelKey: "filters",
                                        iconKey: "filter",
                                        toolPanel: "agFiltersToolPanel"
                                    }
                                ]
                            }}
                            statusBar={{
                                statusPanels: [
                                    {
                                        statusPanel: "agTotalAndFilteredRowCountComponent",
                                        align: "left"
                                    },
                                    {
                                        statusPanel: "agTotalRowCountComponent",
                                        align: "center"
                                    },
                                    { statusPanel: "agFilteredRowCountComponent" },
                                    { statusPanel: "agSelectedRowCountComponent" },
                                    { statusPanel: "agAggregationComponent" }
                                ]
                            }}
                        />
                    </div>
                        </div>
                    </div>
                            <div className="card" style={{width:'100%' ,padding :'20px'}}>
                                <div className="summarised_title">FO Level Report</div>
                        <div className="card-body row">
                        
                       <div class="row" style={{ alignItems: "center", marginBottom: "25px",width:'100%' }}>
                       <div className="col2 mb-2 mr-4">
                                   <div className=""><label>FO Created From Date</label></div>
                                  <div className="">
                                      <DatePicker
                                            selected={dates.startFoDate}
                                            onChange={(date) => handleStartDateChange('startFoDate',date)}
                                            maxDate ={new Date()}
                                            name="startFoDate"
                                            autoComplete="off"
                                            dateFormat="dd/MM/yyyy"
                                            className="datepicker-custom"
                                        />
                                    </div>
                                </div>
                                <div className="col2 mb-2 mr-4">
                                    <div className=""><label>FO Created To Date</label></div>
                                    <div className="">
                                        <DatePicker
                                            selected={dates.endFoDate}
                                            onChange={(date) => handleEndDateChange('endFoDate',date)}
                                            maxDate ={new Date()}
                                            name="endFoDate"
                                            autoComplete="off"
                                            dateFormat="dd/MM/yyyy"
                                            className="datepicker-custom"
                                        />
                                    </div>
                                </div>
                                <div className="form-group col-xl-1 col-lg-1 mb-2">
                                <label></label><br />
                                     <button type="button"  onClick={submitFoEvent} className={"btn btn-success "} id="report-submit">Submit</button>
                                </div>
                                </div>
                            <div id="ctr-gird" className={"ag-theme-balham mt-8 summarised_grid"}>
                                <AgGridReact
                                    onGridReady={(params) => {
                                        gridApiRef.current = params.api
                                    }}
                                    columnDefs={foColumnDefs}
                                    loading={loading?.foloader}
                                    onCellClicked={handleCellClick}
                                    suppressAutoColumns={true}
                                    rowData={gridRowData?.foRowData}
                                    defaultColDef={defaultColDef}
                                    pagination={true}
                                    groupHeaderHeight= {50}
                                    headerHeight= {50}
                                    paginationPageSize={50}
                                    enableRangeSelection={true}
                                    enableCellContextMenu={true}
                                    masterDetail={true}
                                    pinnedBottomRowData ={foGridPinnedBottomRow}
                                    sideBar={{
                                        toolPanels: [
                                            {
                                                id: "columns",
                                                labelDefault: "Columns",
                                                labelKey: "columns",
                                                iconKey: "columns",
                                                toolPanel: "agColumnsToolPanel",
                                                toolPanelParams: {
                                                    suppressPivotMode: true,
                                                    suppressRowGroups: true,
                                                    suppressValues: true,
                                                }
                                            },
                                            {
                                                id: "filters",
                                                labelDefault: "Filters",
                                                labelKey: "filters",
                                                iconKey: "filter",
                                                toolPanel: "agFiltersToolPanel"
                                            }
                                        ]
                                    }}
                                    statusBar={{
                                        statusPanels: [
                                            {
                                                statusPanel: "agTotalAndFilteredRowCountComponent",
                                                align: "left"
                                            },
                                            {
                                                statusPanel: "agTotalRowCountComponent",
                                                align: "center"
                                            },
                                            { statusPanel: "agFilteredRowCountComponent" },
                                            { statusPanel: "agSelectedRowCountComponent" },
                                            { statusPanel: "agAggregationComponent" }
                                        ]
                                    }}
                                />
                            </div>
                        </div>
            </div>
             <div className="card" style={{width:'100%' ,padding :'20px'}}>
                <div className="summarised_title">Force Closure Report</div>
                        <div className="card-body row">
                        
                       <div class="row" style={{ alignItems: "center", marginBottom: "25px",width:'100%' }}>
                       <div className="col2 mb-2 mr-4">
                                   <div className=""><label>From Date</label></div>
                                  <div className="">
                                      <DatePicker
                                            selected={dates.forceClosureStartDate}
                                            onChange={(date) => handleStartDateChange('forceClosureStartDate',date)}
                                            maxDate ={new Date()}
                                            name="forceClosureStartDate"
                                            autoComplete="off"
                                            dateFormat="dd/MM/yyyy"
                                            className="datepicker-custom"
                                        />
                                    </div>
                                </div>
                                <div className="col2 mb-2 mr-4">
                                    <div className=""><label>To Date</label></div>
                                    <div className="">
                                        <DatePicker
                                            selected={dates.forceClosureEndDate}
                                            onChange={(date) => handleEndDateChange('forceClosureEndDate',date)}
                                            maxDate ={new Date()}
                                            name="forceClosureEndDate"
                                            autoComplete="off"
                                            dateFormat="dd/MM/yyyy"
                                            className="datepicker-custom"
                                        />
                                    </div>
                                </div>
                                <div className="form-group col-xl-3 col-lg-3" style={{ zIndex: "8" }}>
                                    <label>Select Zone</label>
                                    <Select
                                        className="border-radius-0"
                                        id="searchForceClosureZone"
                                        name="searchForceClosureZone"
                                        style={{ borderRadius: "0px" }}
                                        value={dropdownZones?.searchForceClosureZone}
                                        onChange={(value, actionMeta) => onChangeZone(value, actionMeta)}
                                        options={zones}
                                        isMulti={true}
                                    />
                                </div>
                                {dropdownZones?.searchForceClosureZone.length >= 1 ? <div className="form-group col-xl-3 col-lg-3" style={{ zIndex: "8" }}>
                                    <label>Select Plant </label>
                                    <Select
                                        className="border-radius-0"
                                        isMulti={true}
                                        style={{ borderRadius: "0px" }}
                                        value={selectedPlant?.forceClosurePlant}
                                        name ="forceClosurePlants"
                                        onChange={(value,actionMeta)=>onChangePlantCode(value,actionMeta)}
                                        options={dropdownPlants?.forceClosurePlants}
                                        closeMenuOnSelect={false}
                                    />
                                </div> : <></>}
                                <div className="form-group col-xl-1 col-lg-1">
                                <label></label><br /> 
                                     <button type="button"  onClick={submitForceClosureEvent} className={"btn btn-success "} id="report-submit">Submit</button>
                                </div>
                                </div>
                            <div id="ctr-gird" className={"ag-theme-balham mt-8 summarised_grid"}>
                                <AgGridReact
                                    columnDefs={forceClosurecolumnDefs}
                                    onGridReady={(params) =>{
                                        forceClosureApiRef.current = params.api
                                    }}
                                    suppressAutoColumns={true}
                                    loading={loading?.forceClosureloader}
                                    rowData={gridRowData?.rowForceClosureData}
                                    defaultColDef={defaultColDef}
                                    pagination={true}
                                    groupHeaderHeight= {50}
                                    headerHeight= {50}
                                    paginationPageSize={50}
                                    enableRangeSelection={true}
                                    enableCellContextMenu={true}
                                    masterDetail={true}
                                    detailCellRendererParams={detailCellRendererParams12?.forceClosureDetailRenderParmas}
                                    pinnedBottomRowData={forceClosureGridPinnedBottomRow}
                                    /></div></div></div>
            <div className={"dataLoadpage " + (loader ? "show-m" : "show-n")}></div>
            <div className={"dataLoadpageimg " + (loader ? "show-m" : "show-n")} style={{ top: "21em" }}>
                <div className="loader-box"><div className="loader-box"><div className="rotate dashed colored"></div></div></div>
            </div>
        </div>
    )
}
export default SummarisedTrackingData;

function sortingDatesInGrid(date1, date2) {
    if (date1 != "" && date2 != "" && date1 != undefined && date2 != undefined) {
        let d1 = moment(date1, 'DD/MMM/YYYY HH:mm')
        let d2 = moment(date2, 'DD/MMM/YYYY HH:mm')
        return d2.isBefore(d1) ? 1 : -1
    }
}